import * as Logger from 'loglevel';
import Storage from '../storage/storage';
import LocalStorageAdapter from '../storage/adapter/local-storage-adapter';

const storage = new Storage(LocalStorageAdapter);

if (storage.get('DEBUG_JS') || process.env.APP_DEBUG === true) {
  Logger.setLevel('DEBUG');
  Logger.debug('Logger set to DEBUG');
} else {
  Logger.setLevel('INFO');
}

export default Logger;
